import PropTypes from "prop-types";

/**
 * Arrow component
 * @param direction
 * @param visibility
 * @param handleClick
 * @param locale
 * @returns {JSX.Element}
 * @constructor
 */
export const Arrow = ({
  direction = "right",
  visibility = true,
  handleClick,
  locale,
}) => {
  return (
    <button
      className={`carousel__arrow ${direction}`}
      onClick={handleClick}
      data-testid={`arrow__${direction}`}
    >
      {visibility ? (
        <svg
          width="10"
          height="22"
          viewBox="0 0 10 22"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M1 21L9 11L1 0.999999" stroke="black" />
        </svg>
      ) : null}
    </button>
  );
};

Arrow.propTypes = {
  direction: PropTypes.oneOf(["left", "right"]),
  visibility: PropTypes.bool,
  handleClick: PropTypes.func,
  locale: PropTypes.string.isRequired,
};
